module.exports = __webpack_public_path__ + "img/nginxwise3.ddd761a0.png";